import type { Deal } from '@/types'
import { dealCountsAsDirectProposalJourneyRisk } from './directProposalJourneyAlert.util'

export function isSlaBreached(deal: Deal) {
  if (deal.stagnant) return true
  if (deal.etapa === 'contrato_enviado' && deal.driftDays >= 3) return true
  if (deal.etapa === 'proposta_enviada' && deal.driftDays >= 5) return true
  return deal.driftDays >= 7
}

export function getColumnMetrics(deals: Deal[]) {
  const value = deals.reduce((sum, deal) => sum + deal.valor, 0)
  const totalAging = deals.reduce((sum, deal) => sum + Math.max(0, deal.driftDays || 0), 0)
  const avgAging = deals.length > 0 ? Math.round(totalAging / deals.length) : 0
  const slaBreaches =
    deals.filter((deal) => isSlaBreached(deal)).length +
    deals.filter(dealCountsAsDirectProposalJourneyRisk).length

  return {
    count: deals.length,
    value,
    avgAging,
    slaBreaches,
    slaLabel: slaBreaches > 0 ? `${slaBreaches} fora do SLA` : 'Operação em dia',
  }
}
